/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type DonateHeartsControlsContainer_user$ref: FragmentReference;
export type DonateHeartsControlsContainer_user = {|
  +id: string,
  +vcCurrent: ?number,
  +$refType: DonateHeartsControlsContainer_user$ref,
|};
*/


const node/*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "DonateHeartsControlsContainer_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "id",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "vcCurrent",
      "args": null,
      "storageKey": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'cc85aa7b76248acc180093074e7d0d4f';
module.exports = node;



// WEBPACK FOOTER //
// ./src/js/components/Donate/__generated__/DonateHeartsControlsContainer_user.graphql.js